import React, { useState, useEffect } from 'react';

const HERO_SLIDES = [
  {
    id: 1,
    text: 'Rise Higher.',
    subtext: 'Operate Smarter.'
  },
  {
    id: 2,
    text: 'Where Strong Foundations',
    subtext: 'Meet Higher Growth.'
  },
  {
    id: 3,
    text: 'Your Peak Partner',
    subtext: 'in Business Success.'
  },
  {
    id: 4,
    text: '',
    subtext: '',
    isLogo: true
  }
];

const AnimatedHero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    if (animationComplete) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => {
        const next = prev + 1;
        if (next >= HERO_SLIDES.length) {
          setAnimationComplete(true);
          clearInterval(timer);
          return HERO_SLIDES.length - 1;
        }
        return next;
      });
    }, 3000);

    return () => clearInterval(timer);
  }, [animationComplete]);

  return (
    <div className="relative w-full h-screen overflow-hidden bg-black">
      {/* Background gradient animation */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="absolute inset-0 opacity-30 hidden md:block" aria-hidden="true">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#B19CD9] rounded-full filter blur-[128px] animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#B19CD9] rounded-full filter blur-[128px] animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
      </div>

      {/* Animated grid pattern */}
      <div className="absolute inset-0 opacity-10 hidden sm:block" aria-hidden="true">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(177, 156, 217, 0.1) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(177, 156, 217, 0.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Content slides */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-4">
          {HERO_SLIDES.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute inset-0 flex flex-col items-center justify-center transition-all duration-1000 ${
                currentSlide === index
                  ? 'opacity-100 scale-100'
                  : 'opacity-0 scale-95 pointer-events-none'
              }`}
            >
              {slide.isLogo ? (
                <div className="flex flex-col items-center">
                  <img
                    src="/sumit-home-logo-optimized.webp"
                    alt="SUM-IT Corporate Services brand logo in the hero section"
                    className="h-auto w-auto max-w-[86vw] max-h-[64vh] md:max-h-[70vh] lg:max-h-[72vh] animate-fade-in"
                    loading="eager"
                    fetchPriority="high"
                    decoding="async"
                    width="960"
                    height="640"
                  />
                </div>
              ) : (
                <>
                  <p className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-4 tracking-tight">
                    {slide.text}
                  </p>
                  {slide.subtext && (
                    <p className="text-4xl md:text-6xl lg:text-7xl font-bold text-[#B19CD9] tracking-tight">
                      {slide.subtext}
                    </p>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Progress indicators - hide when animation is complete */}
      {!animationComplete && (
        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
          {HERO_SLIDES.map((slide) => (
            <div
              key={slide.id}
              className={`h-2 rounded-full transition-all duration-300 ${
                currentSlide === HERO_SLIDES.findIndex((item) => item.id === slide.id)
                  ? 'w-12 bg-[#B19CD9]'
                  : 'w-2 bg-white/30'
              }`}
            />
          ))}
        </div>
      )}

      {/* Scroll indicator - show only when animation is complete */}
      {animationComplete && (
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-[#B19CD9] rounded-full animate-scroll"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnimatedHero;
